import React, {PureComponent} from "react"

import {getResolvedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"

import {Text, Link, Ul, Li, Arrow} from "./styled"

export interface BreadCrumbItem {
  to?: string,
  appContext?: string,
  title: string,
  onClick?: () => void
}

export interface Props {
  data: BreadCrumbItem[],
  className?: string,
  id?: string
}

interface ExtendedProps extends Props, InjectIntl {}

class BreadCrumbs extends PureComponent<ExtendedProps> {
  render() {
    const {data, className} = this.props
    const idNamespace = id("breadcrumbs", this.props)

    return (
      <Ul className={className} id={idNamespace}>
        {data.map((item, index) => {
          const {to, appContext, onClick} = item
          const isLastItem = index === (data.length - 1)
          const isLink = to && !isLastItem
          const Wrapper = isLink ? Link : Text
          const extra:any = {}
          if (isLink) {
            extra.to = to
            if (appContext) {
              extra.app = appContext
            }
          }

          return (
            <Li key={`breadcrumb-item${index}`} onClick={onClick}>
              <Wrapper {...extra}>{getResolvedMessage(this, "title", item)}</Wrapper>
              {!isLastItem && <Arrow />}
            </Li>
          )
        })}
      </Ul>
    )
  }
}

export default injectIntl(BreadCrumbs)
